// extracted by mini-css-extract-plugin
export default {"lds-ring":"circular_lds-ring__ajdIH"};